import SEO from "../ui/SEO.jsx";
import { Link } from "react-router-dom";

export default function Termos() {
  return (
    <div className="max-w-2xl">
      <SEO
        title="Termos de Uso"
        description="Termos de uso e isenção de responsabilidade do Aqui no Japão."
        path="/termos"
      />

      <div className="text-[11px] tracking-[0.18em] uppercase text-accent mb-4 font-semibold">
        Termos
      </div>
      <h1 className="font-serif font-medium text-4xl md:text-5xl leading-tight tracking-tight mb-6">
        Termos de Uso
      </h1>
      <p className="text-sm text-ink-soft font-mono mb-10">
        Última atualização: maio de 2026
      </p>

      <div className="space-y-5 text-[16px] leading-[1.7] text-ink">
        <p>
          Bem-vindo ao Aqui no Japão. Ao usar este site, você concorda com os
          termos abaixo. Linguagem simples, sem letra miúda.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          1. Conteúdo é educacional, não profissional
        </h2>
        <p>
          As calculadoras, guias e textos deste site são informativos e
          educacionais. <strong>Não substituem aconselhamento profissional</strong>{" "}
          de contadores (税理士), advogados (弁護士), planejadores financeiros
          ou autoridades japonesas competentes.
        </p>
        <p>
          Para decisões importantes (imposto, aposentadoria, visto,
          residência fiscal), procure um profissional qualificado ou a fonte
          oficial.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          2. Precisão das calculadoras
        </h2>
        <p>
          As calculadoras usam tabelas e fórmulas oficiais publicadas pela
          National Tax Agency, Japan Pension Service e fontes equivalentes.
          Mesmo assim, são <strong>estimativas</strong>. Variáveis como:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Taxa de kokumin kenko hoken por município (varia de 7% a 13%)</li>
          <li>Bônus específicos da sua empresa</li>
          <li>Deduções pessoais não previstas (mochi-bun, etc.)</li>
          <li>Mudanças de lei após a última atualização do site</li>
        </ul>
        <p>
          podem fazer o resultado real diferir da estimativa. Use o número como
          ponto de partida, não como verdade absoluta.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          3. Cotação cambial
        </h2>
        <p>
          As cotações vêm da API pública{" "}
          <strong>frankfurter.app</strong> (taxas do Banco Central Europeu,
          atualizadas a cada dia útil). Não são cotações de remessa
          comercial — bancos e serviços de transferência cobram spread além
          dessa cotação base.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          4. Links externos
        </h2>
        <p>
          Alguns links do site (especialmente na calculadora de remessas)
          podem ser de afiliados. Isso significa que se você se cadastrar
          via nosso link, recebemos uma pequena comissão.{" "}
          <strong>Você não paga nada a mais por isso</strong> — pelo
          contrário, geralmente nossos links têm bônus ou desconto.
        </p>
        <p>
          Só recomendamos serviços que nós mesmos usaríamos. Se algum serviço
          parar de ser bom, removemos do site, mesmo perdendo a comissão.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          5. Publicidade
        </h2>
        <p>
          O site exibe anúncios via Google AdSense para se manter gratuito.
          Anúncios são identificados como tal. Não temos controle sobre os
          anunciantes específicos que aparecem — o Google escolhe baseado no
          seu perfil. Se você ver um anúncio inadequado, pode reportá-lo
          clicando no &ldquo;i&rdquo; do anúncio.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          6. Limitação de responsabilidade
        </h2>
        <p>
          O site é fornecido &ldquo;como está&rdquo;. Não nos responsabilizamos
          por:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>Perdas financeiras decorrentes de decisões baseadas no site</li>
          <li>Erros ou desatualizações nas calculadoras ou guias</li>
          <li>Indisponibilidade temporária do site</li>
          <li>Conteúdo de sites de terceiros linkados</li>
        </ul>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          7. Mudanças nos termos
        </h2>
        <p>
          Estes termos podem mudar. A data no topo será atualizada. Continuar
          usando o site após mudanças implica aceitação dos novos termos.
        </p>

        <h2 className="font-serif font-medium text-2xl mt-10 mb-3">
          8. Contato
        </h2>
        <p>
          Dúvidas ou correções:{" "}
          <a
            href="mailto:hello@aquinojapao.com"
            className="text-accent underline"
          >
            hello@aquinojapao.com
          </a>
          . Veja também a{" "}
          <Link to="/privacidade" className="text-accent underline">
            Política de Privacidade
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
